/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import * as Msdyn365 from '@msdyn365-commerce/core';
export class GetComfortTypesData extends Msdyn365.CommerceEntityInput implements Msdyn365.IActionInput {
    private comfortTypesDataUrl: string = '';
    constructor(comfortTypesDataUrl: string) {
        super({ shouldCacheOutput: true, cacheObjectType: 'comfortTypesDataCache', cacheKey: 'comfortTypesDataCache' });
        this.comfortTypesDataUrl = comfortTypesDataUrl;
    }
    public getComfortTypesDataUrl = () => this.comfortTypesDataUrl;
    public getCacheKey = () => `comfortTypesDataCache`;
    public getCacheObjectType = () => 'comfortTypesDataCache';
    public dataCacheType = (): Msdyn365.CacheType => 'request';
}
const createInput = (inputData: Msdyn365.ICreateActionContext<Msdyn365.IGeneric<Msdyn365.IAny>>): Msdyn365.IActionInput => {
    if (inputData.config && inputData.config.comfortTypesDataUrl) {
        return new GetComfortTypesData(inputData.config.comfortTypesDataUrl);
    }
    return new GetComfortTypesData('');
};
async function action(input: GetComfortTypesData, ctx: Msdyn365.IActionContext): Promise<any> {
    const comfortTypesDataJsonUrl = ctx.requestContext.app.config.comfortTypesDataJsonUrl;
    const jsonUrl = comfortTypesDataJsonUrl || '';
    const res = await Msdyn365.sendRequest<any>(jsonUrl, 'get');
    const comfortTypesData = res.data && res.data;
    return comfortTypesData;
}
export default Msdyn365.createObservableDataAction({
    id: 'ComfortTypesDataCache',
    action: <Msdyn365.IAction<any>>action,
    input: createInput
});